<script setup lang="ts">
import { computed } from 'vue'
import { useAccessStore } from '@/stores/access'
import { useRoute } from 'vue-router'

import RolesEditor from '@/components/roles/RolesEditor.vue'

const accessStore = useAccessStore()
const route = useRoute()

const loaded = computed(() => accessStore.loaded)
const roleId = computed(() => Number(route.params.role_id))
</script>

<template>
  <RolesEditor v-if="loaded" :key="roleId" :role-id="roleId" />
</template>
